import { useState, useEffect, useCallback, useRef } from 'react';

type CallbackFunction<T> = (param: T) => void | Promise<void>;
/**
 * Hook que detecta cuando se regresa a la página anterior
 * @param callback  -- Función a ejecutar
 * @param param -- Parámetro/s de la función
 * @returns void
 */
const useBackDetection = <T,>(callback: CallbackFunction<T>, param: T): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [isTriggered, setIsTriggered] = useState<boolean>(false);
  const hasRequested = useRef(false);

  const handleBackNavigation = useCallback(() => {
    if (!hasRequested.current) {
      setIsTriggered(true);
      callback(param);
      hasRequested.current = true;
    }
  }, [callback, param]);
  const handleBeforeUnload = useCallback((event: BeforeUnloadEvent) => {
    if (!hasRequested.current) {
      setIsTriggered(true);
      event.preventDefault();
      event.returnValue = '';
      callback(param);
      hasRequested.current = true;
    }
  }, [callback, param]);

  useEffect(() => {
    window.addEventListener('popstate', handleBackNavigation);
    window.addEventListener('beforeunload', handleBeforeUnload);

    if (isTriggered) {
      return () => {
        window.removeEventListener('popstate', handleBackNavigation);
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, []);
  return [isTriggered, setIsTriggered];
};
export default useBackDetection;
